// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"baca7320","835":"3bc8ef4d"}[chunkId] + ".chunk.js";
};